import {  IDebtorHistory} from 'us.collection.debtor/Interfaces'
import dayjs from 'dayjs';

export const debtorHistory: IDebtorHistory[] = [{
    id: 0,
    debtorNo: 0,
    fullName: "",
    birthDate:dayjs('0001-01-01T00:00:00'),
    personNo: '',
    title: "First Name",
    orginalRegDate: dayjs('0001-01-01T00:00:00'),
    regDate: dayjs('0001-01-01T00:00:00'),
    createdUser: "",
    modifiedUser: ""
}]